import axios from 'axios'

export const AXIOS = axios.create({
  proxy: {
    host: 'http://localhost',
    port: 8088,
  },
})
